import { Expose } from 'class-transformer';

export class AlcoholTestRequestDeliveredResponse {

    sideNumber: string;

    @Expose({name: 'timestamp'})
    receiveTime: Date;
}
